import UADetector from 'Helper/UADetector';
import localforage from 'localforage';
import LocalStorage from '../LocalStorage';

/**
 * Values stored through this shim are plain JSON-serialisable data.
 * Kept structural rather than a union of every caller's shape, so this
 * low-level storage helper does not depend on feature modules.
 */
type DataType = string | number | LanguageCode | object | null;

const { isIPhone } = UADetector();

const LocalforageIphoneFix = {
    getItem: async (key: string): Promise<DataType> => {
        if (isIPhone) {
            return new Promise(async (resolve, reject) => {
                try {
                    const value = LocalStorage.get(key);
                    resolve(value ? JSON.parse(value) : null);
                } catch (error) {
                    reject(error);
                }
            });
        }

        return localforage.getItem(key);
    },

    removeItem: (key: string): Promise<void> => {
        if (isIPhone) {
            return new Promise((resolve, reject) => {
                try {
                    LocalStorage.remove(key);

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        }

        return localforage.removeItem(key);
    },

    setItem: (key: string, data: DataType): void => {
        if (isIPhone) {
            LocalStorage.set(key, JSON.stringify(data));
            return;
        }

        localforage.setItem(key, data);
    },
};

export default LocalforageIphoneFix;
